"use client"

import { useMemo } from "react"
import { formatPriceLong } from "src/utilities/price"
import { useCartState } from "./useCart"

function parsePrice(value: string | undefined) {
  if (!value) {
    return 0
  }
  return Number(value) / 100
}

export function useCoupons() {
  const { data: cart } = useCartState()

  return useMemo(() => {
    return (cart?.coupons || []).map((coupon) => {
      const code = coupon.code.toUpperCase()
      const totalDiscount = parsePrice(coupon.totals.total_discount)
      const totalDiscountTax = parsePrice(coupon.totals.total_discount_tax)

      const discount = totalDiscount + totalDiscountTax
      const discountFormatted = discount > 0 ? formatPriceLong(discount) : ""

      return { code, discount, discountFormatted }
    })
  }, [cart?.coupons])
}
